import React, { useState } from 'react'
import Loader from './shared/Loader'
import { validateEmail, showFlashMessage } from '../helpers/utils'

export default function EmailFieldForm({ formPath, emailValue, refParams, glfp, buttonTitle, termsUrl, privacyUrl, addendumUrl }) {
  const [email, setEmail] = useState(emailValue)
  const [loading, setLoading] = useState(false)

  const disableSubmit = !(validateEmail(email))

  function handleSubmit(event) {
    event.preventDefault()

    if (email.length === 0) {
      showFlashMessage(Cas.translations.email_blank, 'error')
    } else if (!validateEmail(email)) {
      showFlashMessage(Cas.translations.email_invalid, 'error')
    } else {
      save()
    }
  }

  function save(event) {
    setLoading(true)

    let formData = new FormData()
    formData.append('account[email]', email)

    for(const refParamKey in refParams) {
      formData.append(refParamKey, refParams[refParamKey])
    }

    if(glfp) {
      formData.append('glfp', glfp)
    }

    Rails.ajax({
      type: 'POST',
      url: formPath,
      dataType: 'json',
      data: formData,
      success: res => {
        setEmail('')
        setLoading(false)
        showFlashMessage(res.message, 'success')
      }
    })
  }

  return (
    <>
      <div className='field'>
        <label>
          { Cas.translations.email }
        </label>
        <input
          type='email'
          autoFocus
          autoComplete='email'
          placeholder='some@example.com'
          value={ email }
          onChange={ event => setEmail(event.target.value) }
        />
      </div>

      <div className='actions'>
        { !loading ?
          <div className='flex-box items-center content-center'>
            <button type='submit' className={`button ${disableSubmit ? 'disabled' : ''}`} onClick={ handleSubmit }>
              { buttonTitle  }
            </button>
          </div>
          :
          <div className='flex-box content-center'>
            <Loader size='small' position='centered'/>
          </div>
        }
      </div>
    </>
  )
}
